import {getColumnsByNames} from './all-top10-columns-config';

export const topBlockedServicesReportConfig = getColumnsByNames([
    {name: 'transport', width: '10%'},
    {name: 'dport', header: 'Destination Port'},
    { name: 'count', width: '40%' },
    { name: 'percentOfTotal', header: '% Blocked Services', width: '145px' }
]);